import { HttpClient } from '@angular/common/http';
import { Injectable, WritableSignal, signal } from '@angular/core';
import { TagDto } from '@picflow/types';
import { AppConfigService } from './providers/config.service';
import { DataLoaderService } from './services/data-loader.service';

@Injectable({
  providedIn: 'root',
})
export class TagService {
  constructor(private http: HttpClient, private config: AppConfigService, private loader: DataLoaderService) {}

  tags: WritableSignal<TagDto[]> = signal(undefined);

  public getTags() {
    const url = `${this.config.apiEndpoint}/tags`;
    this.http.get<{ data: TagDto[] }>(url).subscribe(resp => {
      this.tags.set(resp.data);
    });
  }

  public createTag(name: string, category: string) {
    this.http
      .post<TagDto>(`${this.config.apiEndpoint}/tags`, { name, category })
      .subscribe(resp => this.tags.mutate(tags => tags.push(resp)));
  }

  public deleteTag(tagId: string) {
    this.http
      .delete(`${this.config.apiEndpoint}/tags/${tagId}`)
      .subscribe(() => this.tags.update(tags => tags.filter(tag => tag.id !== tagId)));
    this.loader.remove('assets');
  }
}
